@if (visible()) {
  <div class="sens-cookie">
    <div class="sens-cookie__inner">
      <p class="sens-cookie__text">
        We use cookies and similar technologies to operate the platform, remember your preferences,
        and measure traffic. See our <a [routerLink]="['/documents', 'privacy']">Privacy Policy</a>.
      </p>
      <div class="sens-cookie__actions">
        <button type="button" class="sens-cookie__btn sens-cookie__btn--ghost" (click)="decline()">Decline</button>
        <button type="button" class="sens-cookie__btn sens-cookie__btn--primary" (click)="accept()">Accept</button>
      </div>
    </div>
  </div>
}
